module.exports = __webpack_public_path__ + "static/media/img_plan_basic.6e8c9e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_basic.svg
// module id = 383
// module chunks = 0